import type { Field } from '@sevenrooms/form'
import { useLocales } from '@sevenrooms/locales'
import { FormInput, Label } from '@sevenrooms/ui-kit/form'
import { reservationWidgetMessages } from '../../reservationWidgetMessages'

export interface PrivateEventNameFormProps {
  privateEventNameField: Field<string | null>
}

export function PrivateEventNameForm({ privateEventNameField }: PrivateEventNameFormProps) {
  const { formatMessage } = useLocales()

  const labelMessage = formatMessage(reservationWidgetMessages.resWidgetPrivateEventNameLabel)

  return (
    <Label primary={`${labelMessage}`}>
      <FormInput
        aria-required="false"
        data-test="sr-reservation-private-event-name"
        field={privateEventNameField}
        fullWidth
        placeholder={labelMessage}
      />
    </Label>
  )
}
